function ConditionController(psaService) {
  const ctrl = this;

  ctrl.$onInit = function() {
    ctrl.psaService = psaService;
    ctrl.types = [
      { type: 'Event', id: 0 },
      { type: 'Condition indicator', id: 1 },
    ];
    ctrl.cis = ['CI 1', 'CI 2', 'CI 3'];
    ctrl.eventState = [
      { label: 'Active', value: true },
      { label: 'Not active', value: false },
    ];
    ctrl.operators = ['and', 'or'];
    if (ctrl.viewMode) {
      ctrl.editMode = false;
    } else {
      ctrl.editMode = true;
    }
    ctrl.loadEvents();
  };

  ctrl.$onChanges = function(changes) {
    if (changes.newCondition) {
      ctrl.newCondition = angular.copy(ctrl.newCondition);
      if (ctrl.viewMode) {
        if (ctrl.newCondition.type === 'EVENT') {
          ctrl.newCondition.type = 0;
        }
      }
    }
  };

  ctrl.removeCondition = function() {
    ctrl.onRemove({
      $event: {
        conditionIndex: ctrl.index,
      },
    });
  };

  ctrl.saveCondition = function() {
    ctrl.editMode = false;
    ctrl.newCondition.eventId = _.findKey(ctrl.events, event => {
      return event === ctrl.newCondition.name;
    });
    ctrl.onSave({
      $event: {
        conditionIndex: ctrl.index,
        newCondition: ctrl.newCondition,
      },
    });
  };

  ctrl.enableEdit = function() {
    ctrl.editMode = true;
    ctrl.onEdit();
  };

  ctrl.loadEvents = () => {
    ctrl.psaService.getEvents().then(function(data) {
      ctrl.events = data;
    });
  };
}

angular
  .module('psa.module')
  .controller('ConditionController', ConditionController);
